import { KnowledgeFrame } from '../components/KnowledgeNav'
import { DomainAgenda } from '../components/DomainAgenda'

export function DomainsPage() {
  return (
    <KnowledgeFrame
      title="Research domains"
      description="Explore the maintained research agenda, shared concepts, qualified evidence and review outcomes."
    >
      <DomainAgenda />
    </KnowledgeFrame>
  )
}
